import AccordionBase from '@studiometa/js-toolkit/components/Accordion';
import scroll from '../utils/scroll';

/**
 * @typedef {import('@studiometa/js-toolkit/components/Accordion/AccordionItem').default} AccordionItem
 */

/**
 * @typedef {Object} AccordionRef
 */

/**
 * @typedef {Object} AccordionInterface
 * @property {AccordionRef} $refs
 */

/**
 * Homepage class.
 */
export default class Accordion extends AccordionBase {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    ...AccordionBase.config,
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Accordion & AccordionInterface}
   * @return {Promise<void>}
   */
  async mounted() {
    this.$on('open', this.onOpen.bind(this));
    return AccordionBase.prototype.mounted.call(this);
  }

  /**
   * Handle the `open` event.
   *
   * @param {AccordionItem} item
   * @param {Number} index
   */
  onOpen(item, index) {
    const headerHeight = document.querySelector('header.header').clientHeight;
    const baseTop = this.$el.getBoundingClientRect().top;
    let finalTop = baseTop;

    for (let i = 0; i < index; i += 1) {
      finalTop += this.$children.AccordionItem[index].$refs.btn.getBoundingClientRect().height;
    }

    if (finalTop < headerHeight) {
      scroll(finalTop + window.scrollY - headerHeight, 400);
    }
  }
}
